import { cloneDeepWith } from "lodash";
import { Type } from "./type";

/** Type 是不可变的属性单例，其余领域对象均独立克隆并保留原型。 */
export function cloneBattleState<T>(value: T): T {
    return cloneDeepWith(value, (nested) => (nested instanceof Type ? nested : undefined));
}
